import React, { memo } from 'react';
import PropTypes from 'prop-types';
import animateLoader from 'desktop/utils/animateLoader';
import {
  LoaderStyled,
  StyledText,
  LoaderCircle,
  LoaderContent,
  LoaderSvg,
  VideoSvg,
} from './styles/LoaderStyled';

const Loader = ({ type, text, strokeWidth, strokeMiterlimit, color, fill, background }) => {
  const getSvgRef = (ref) => {
    animateLoader(ref, 1, 0, 1);
  };

  const renderLoaderContent = () => {
    switch (true) {
      case type === 'video':
        return (
          <VideoSvg x="0" y="0" viewBox="0 0 125 4" enableBackground="new 0 0 0 0" fill={fill}>
            <rect x="0" y="0" width="20" height="4">
              <animate
                attributeName="opacity"
                dur="1s"
                values="0.1;1;0.1"
                repeatCount="indefinite"
                begin="0.1"
              />
            </rect>
            <rect x="25" y="0" width="20" height="4">
              <animate
                attributeName="opacity"
                dur="1s"
                values="0.1;1;0.1"
                repeatCount="indefinite"
                begin="0.2"
              />
            </rect>
            <rect x="50" y="0" width="20" height="4">
              <animate
                attributeName="opacity"
                dur="1s"
                values="0.1;1;0.1"
                repeatCount="indefinite"
                begin="0.3"
              />
            </rect>
            <rect x="75" y="0" width="20" height="4">
              <animate
                attributeName="opacity"
                dur="1s"
                values="0.1;1;0.1"
                repeatCount="indefinite"
                begin="0.4"
              />
            </rect>
            <rect x="100" y="0" width="20" height="4">
              <animate
                attributeName="opacity"
                dur="1s"
                values="0.1;1;0.1"
                repeatCount="indefinite"
                begin="0.5"
              />
            </rect>
          </VideoSvg>
        );

      default:
        return (
          <LoaderContent>
            <LoaderSvg viewBox="25 25 50 50">
              <LoaderCircle
                ref={getSvgRef}
                cx="50"
                cy="50"
                r="20"
                fill="none"
                strokeWidth={strokeWidth}
                strokeMiterlimit={strokeMiterlimit}
                stroke={color}
              />
            </LoaderSvg>
            {text !== '' && (
              <StyledText size="xxs" type="uppercase" color="white">
                {text}
              </StyledText>
            )}
          </LoaderContent>
        );
    }
  };

  return (
    <LoaderStyled type={type} background={background}>
      {renderLoaderContent()}
    </LoaderStyled>
  );
};

Loader.propTypes = {
  text: PropTypes.string,
  strokeWidth: PropTypes.number,
  strokeMiterlimit: PropTypes.number,
  color: PropTypes.string,
  type: PropTypes.string,
  fill: PropTypes.string,
  background: PropTypes.bool,
};

Loader.defaultProps = {
  text: '',
  strokeWidth: 4,
  strokeMiterlimit: 10,
  color: '#A6A6A6',
  type: null,
  fill: '#ff6600',
  background: false,
};

export default memo(Loader);
